const queryString = require('query-string');

import {serialize} from 'dom-form-serializer';
import setRequestHeaders from './set-request-headers'
import ReplaceElements from "./replace-elements";
import initAfterReplace from "./init-after-replace";
import goTo from "./go-to";
import Module from "./module";
import NProgress from 'nprogress';

const NAME_INSTANCE = 'ajaxFormInstance'

const xhrStateChange = (ev) => {
    let xhr = ev.target
    // Check the request is complete
    if (xhr.readyState != 4) {
        return;
    }
    if (parseInt(xhr.status) === 200) {
        NProgress.done()
        let data = JSON.parse(xhr.responseText);

        if (data.attrs && Array.isArray(data.attrs)) {
            for (const selector in data.attrs) {
                let elements = document.querySelectorAll(selector)
                for (let i = 0; i < elements.length; i++) {
                    let element = elements[i]
                    for (const attrKey in data.attrs[selector]) {
                        element.setAttribute(attrKey, data.attrs[selector][attrKey])
                    }
                }
            }
        }
        if (data.elements && Array.isArray(data.elements)) {
            ReplaceElements(data.elements, (newElement) => {
                initAfterReplace(newElement)
            })
        }

        if (data.href) {
            goTo(data.href, true)
        }
    }
}

const xhrError = () => {
    NProgress.done()
}

const on = (element, events, callback) => {
    events.forEach(function (e) {
        element.removeEventListener(e, callback);
        element.addEventListener(e, callback)
    })
}

const off = (element, events, callback) => {
    events.forEach(function (e) {
        element.removeEventListener(e, callback);
    })
}

const changeHandle = (ev) => {
    if (!ev) {
        return;
    }

    let target = ev.target;

    let form = this || target.parentFormElement;

    if (!form) {
        return;
    }

    if (target.hasAttribute('data-ajax-ignore')) {
        let ignoreValue = target.getAttribute('data-ajax-ignore')
        if (ignoreValue) {
            if (form.tagName !== 'FORM') {
                if (ignoreValue === 'form-element') {
                    return;
                }
            } else {
                if (ignoreValue === 'form') {
                    return;
                }
            }
        } else {
            return;
        }
    }

    if (form.tagName !== 'FORM') {
        form = target.parentFormElement;
    }

    const th = form[NAME_INSTANCE]

    // Нет смысла останавливать событие если не найдена форма
    ev.preventDefault && ev.preventDefault()
    ev.stopPropagation && ev.stopPropagation()

    let url = form.getAttribute('data-form-url')
    let method = form.getAttribute('data-form-method')

    if (form.tagName === 'FORM') {
        if (!url) {
            url = form.action
            method = form.method
            let _method = form.querySelector('[name="_method"]');
            if (_method && _method.value) {
                method = _method.value;
            }
        }
    }
    method = method.toUpperCase();

    form.xhr = form.xhr || new XMLHttpRequest()

    let xhrAbortName = th.settings.xhrAbortName
    if (xhrAbortName) {
        if (window[xhrAbortName] && window[xhrAbortName].abort) {
            window[xhrAbortName].abort()
        }
        window[xhrAbortName] = form.xhr
    }

    if (parseInt(form.xhr.status) !== 0) {
        form.xhr.abort();
    }

    on(form.xhr, ['readystatechange'], xhrStateChange);
    on(form.xhr, ['error'], xhrError);

    let data = serialize(form);


    for (const dataKey in data) {
        if (data[dataKey] === null) {
            let hiddenElements = form.querySelectorAll(`input[name="${dataKey}"]`)
            for (let i = 0; i < hiddenElements.length; i++) {
                let hiddenElement = hiddenElements[i]
                if (hiddenElement.value) {
                    if (hiddenElement.type === 'checkbox' || hiddenElement.type === 'radio') {
                        if (hiddenElement.checked) {
                            data[dataKey] = hiddenElement.value;
                            break;
                        }
                    } else {
                        data[dataKey] = hiddenElement.value;
                        break;
                    }
                }
            }
        }
    }

    if (target.tagName === 'BUTTON' && target.name && target.value) {
        data[target.name] = target.value;
    }

    let postData = method !== 'GET' ? JSON.stringify(data) : null

    if (method === 'GET' && url.indexOf('?') !== -1) {
        let urlArray = url.split('?')
        url = urlArray[0]
        let strParams = urlArray[1]
        let urlParams = queryString.parse(strParams, {arrayFormat: 'bracket'});
        data = Object.assign(urlParams, data)
    }

    for (const dataKey in data) {
        let item = data[dataKey]
        if (Array.isArray(item) && item.length === 1 && Array.isArray(item[0]) && item[0].length === 0) {
            data[dataKey] = []
        }
    }

    if (method === 'GET') {
        let params = queryString.stringify(data, {arrayFormat: 'bracket'});
        if (params) {
            url += '?' + params
        }
    }

    form.xhr.open(method, url, true)

    form.xhr = setRequestHeaders(form.xhr)
    form.xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    if (target.name) {
        form.xhr.setRequestHeader("X-CHANGE-NAME", target.name);
    }
    NProgress.configure({easing: 'ease', speed: 500});
    NProgress.start();
    form.xhr.send(postData);
}

export default class AjaxForm extends Module {
    /**
     * @type string
     */
    nameInstance = NAME_INSTANCE

    /**
     * @type string
     */
    SELECTOR = '[data-ajax]'

    /**
     * @type string
     */
    ATTR_NAME = 'data-ajax'

    /**
     * @type Object
     */
    settings = {
        ajaxEvents: null,
        controlsSelector: null,
        buttonsSelector: null,
        xhrAbortName: '',
    }
    childrenFields = []
    childrenButtons = []

    constructor(element, settings) {
        super();
        this._constructor(element, settings)
    }

    // Public Methods
    destroy() {
        const element = this.element

        if (element) {
            let ajaxEvents = this.settings.ajaxEvents
            let childrenFields = this.childrenFields
            let childrenButtons = this.childrenButtons

            off(element, ajaxEvents, changeHandle)

            for (let j = 0; j < childrenButtons.length; j++) {
                let childrenButton = childrenButtons[j]
                off(childrenButton, ['click'], changeHandle)
            }

            for (let j = 0; j < childrenFields.length; j++) {
                let childrenField = childrenFields[j]
                off(childrenField, ajaxEvents, changeHandle)
            }
        }
    }

    getNewModule(element) {
        return new AjaxForm(element)
    }

    // Private Methods
    _implementation() {
        const element = this.element
        const settings = this.settings
        if (!element) {
            return;
        }

        let ajaxEvents = settings.ajaxEvents
        let controlsSelector = settings.controlsSelector
        let buttonsSelector = settings.buttonsSelector

        on(element, ajaxEvents, changeHandle)

        let childrenFields = element.querySelectorAll(controlsSelector);

        for (let j = 0; j < childrenFields.length; j++) {
            let childrenField = childrenFields[j]
            childrenField.parentFormElement = element
            on(childrenField, ajaxEvents, changeHandle)
        }

        let childrenButtons = element.querySelectorAll(buttonsSelector);

        for (let j = 0; j < childrenButtons.length; j++) {
            let childrenButton = childrenButtons[j]
            childrenButton.parentFormElement = element
            on(childrenButton, ['click'], changeHandle)
        }

        this.childrenFields = childrenFields
        this.childrenButtons = childrenButtons
    }

    _initSettings(element, settings) {
        settings = Object.assign(this.settings, (settings || {}))

        if (element) {
            settings.ajaxEvents = element.getAttribute('data-ajax').split('|')

            let controlsSelector = 'input:not([data-ajax-ignore]), select:not([data-ajax-ignore]), textarea:not([data-ajax-ignore])'
            let buttonsSelector = 'button[type="submit"]:not([data-ajax-ignore])'

            if (element.tagName !== 'FORM') {
                controlsSelector += ', input:not([data-ajax-ignore="form-element"]), select:not([data-ajax-ignore="form-element"]), textarea:not([data-ajax-ignore="form-element"])'
                buttonsSelector += ', button[type="submit"]:not([data-ajax-ignore="form-element"])'
            } else {
                controlsSelector += ', input:not([data-ajax-ignore="form"]), select:not([data-ajax-ignore="form"]), textarea:not([data-ajax-ignore="form"])'
                buttonsSelector += ', button[type="submit"]:not([data-ajax-ignore="form"])'
            }
            settings.controlsSelector = controlsSelector
            settings.buttonsSelector = buttonsSelector

            settings.xhrAbortName = element.getAttribute('data-ajax-abort') || settings.xhrAbortName
        }

        this.settings = settings
    }
}
